// extracted by mini-css-extract-plugin
export default {"animatedIcon":"W_tGJ9","root":"CtWqH7","withCustomPadding":"iy8Yv5","content":"LG6L15","withCustomBackgroundColor":"n16MRa"};